module.exports = __webpack_public_path__ + "static/media/Овчинников Александр Валерьевич Стоп, снято «Жестокий романс» о бесприданнице Костромская обл.-1.png";